/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VoidPaymentRequest
 */
export interface VoidPaymentRequest {
    /**
     * 
     * @type {string}
     * @memberof VoidPaymentRequest
     */
    transactionId: string;
    /**
     * 
     * @type {number}
     * @memberof VoidPaymentRequest
     */
    voidAmount: number;
    /**
     * 
     * @type {string}
     * @memberof VoidPaymentRequest
     */
    note: string | null;
}

/**
 * Check if a given object implements the VoidPaymentRequest interface.
 */
export function instanceOfVoidPaymentRequest(value: object): value is VoidPaymentRequest {
    if (!('transactionId' in value) || value['transactionId'] === undefined) return false;
    if (!('voidAmount' in value) || value['voidAmount'] === undefined) return false;
    if (!('note' in value) || value['note'] === undefined) return false;
    return true;
}

export function VoidPaymentRequestFromJSON(json: any): VoidPaymentRequest {
    return VoidPaymentRequestFromJSONTyped(json, false);
}

export function VoidPaymentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): VoidPaymentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'transactionId': json['transactionId'],
        'voidAmount': json['voidAmount'],
        'note': json['note'],
    };
}

export function VoidPaymentRequestToJSON(json: any): VoidPaymentRequest {
    return VoidPaymentRequestToJSONTyped(json, false);
}

export function VoidPaymentRequestToJSONTyped(value?: VoidPaymentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'transactionId': value['transactionId'],
        'voidAmount': value['voidAmount'],
        'note': value['note'],
    };
}

